import React from 'react';

import MuiSkeleton, {
  SkeletonProps as MuiSkeletonProps,
} from '@mui/material/Skeleton';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const Skeleton = withCoreProps<SkeletonProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<SkeletonProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiSkeleton {...props} className={clsxClass}>
        {children}
      </MuiSkeleton>
    );
  },
);

export interface SkeletonProps extends MuiSkeletonProps, CoreProps {}
